import { commonBase } from '@kid/meta-color/color/output/all';
import { useStyle } from '../../hooks/useStyle';
export function useRadioStyle() {
    const radioStyle = useStyle({
        base: {
            width: 16,
            height: 16,
            borderRadius: 8,
            borderWidth: 2,
            borderColor: commonBase.kiui_color_base_black_8,
        },
        disable: {
            backgroundColor: commonBase.kiui_color_base_black_9,
        },
        unCheck: {
            backgroundColor: commonBase.kiui_color_base_white_1,
        },
        textStyle: {
            color: commonBase.kiui_color_base_black_1_a88,
            fontSize: 14,
        },
    });
    return {
        radioStyle,
    };
}
